import { render, staticRenderFns } from "./Kendaraan.vue?vue&type=template&id=3b25b2b1&"
import script from "./Kendaraan.vue?vue&type=script&lang=js&"
export * from "./Kendaraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports